module.exports = __webpack_public_path__ + "static/media/meiben03.c9c4453a.jpg";